import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import axios from 'axios';

export async function getPlanos(database) {
  try {
    const empresaDoc = await getDoc(doc(db, "empresas", database));
    if (!empresaDoc.exists()) {
      console.log("Empresa não encontrada!");
      return null;
    }
    const empresaData = empresaDoc.data();
    const planCode = empresaData.plan;
    if (!planCode) {
      console.log("Empresa não possui plano associado");
      return null;
    }
    const planoDoc = await getDoc(doc(db, "planos", planCode.toString()));
    if (!planoDoc.exists()) {
      console.log("Plano não encontrado!");
      return null;
    }
    const planoData = planoDoc.data();
    return planoData;
  } catch (error) {
    console.error("Erro nas consultas:", {
      message: error.message,
      code: error.code,
      stack: error.stack
    });
    throw error;
  }
}

export async function getAllPlanos(){  
  const url = process.env.VUE_APP_APIURL
  try {
    const res = await axios.get(`${url}/public/companies/plans`, {
    });
    return res.data;
  } catch (error) {
    console.error('Erro: ', error);
    throw error;
  }
}